module.exports = "/_next/static/images/2afb91f5f2598d7e76799f50b82836f9-blog1-lg.png";